export const iconFontAwesomeAccessibilityUniversalAccess = (
	<i className="fa-solid fa-universal-access"></i>
);
